















import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import {nil, VuetifyColorSetting} from '@/common';
@Component({
    components: {
    },
})
export default class GenericDialog extends Vue {
    public innerOpen = false;

    @Prop({default: 600})
    public maxWidth!: number;

    @Prop({default: true})
    public fullScreenOnMobile!: boolean;

    @Prop({default: () => ({color: '', dark: false})})
    public color!: VuetifyColorSetting;

    @Prop({default: () => ({color: '', dark: false})})
    public toolbarColor!: VuetifyColorSetting;

    @Prop({default: false})
    public dark!: boolean;

    @Prop({default: true})
    public closeable!: boolean;

    @Prop({default: ''})
    public title!: string;

    @Prop({default: false})
    public value!: boolean;

    @Prop({default: () => null})
    public maxHeight!: number|null;

    @Watch('value')
    public onValueChanged(value: boolean, oldValue: boolean) {
        this.innerOpen = value;
    }

    @Watch('innerOpen')
    public onInnerOpenChanged(value: boolean, oldValue: boolean) {
        this.$emit('input', value);
    }

    public get shouldFullscreen() {
        return this.isXS(null) && this.fullScreenOnMobile;
    }
    public get shouldShowCloseIcon() {
        return this.shouldFullscreen || this.closeable;
    }
    public get shouldBeScrollable() {
        return !nil(this.maxHeight);
    }
    public get style() {
        return this.shouldBeScrollable ? `max-height:${this.maxHeight}px` : '';
    }
}
